import { callAPI } from "../config/AxiosTemplate";
import { API_RESPONSE_STATUS_CODES, API } from "../Utils/Constants";
import { SAVE_LOAN_ID, SAVE_USER_NAME } from "./Constants";

export const getAuditTrailAction = (request, callback) => {
  callAPI(
    "getAuditTrail",
    API.getAuditTrail,
    "POST",
    request,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(apiResponse);
      }
    }
  );
};

export function saveUserName(data) {
  return function (dispatch) {
    dispatch({
      type: SAVE_USER_NAME,
      data: data,
    });
  };
}

export function saveLoanID(data) {
  return function (dispatch) {
    dispatch({
      type: SAVE_LOAN_ID,
      data: data,
    });
  };
}
